// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-csv-viewer{background:#fff;height:100%;overflow:auto;position:relative}.ac-csv-viewer .ac-table__cell:not(:last-child),.ac-csv-viewer .ac-table__header-cell:not(:last-child){border-right:1px solid #E1E1E1}\n", ""]);
// Exports
module.exports = exports;
